import { fromJS, Map } from 'immutable';

const NAME_SPACE = 'TICKETS/INDEX';

const initialState = new Map({
  pageSize: 0,
  currentPage: 0,
  count: 0,
  data: fromJS([]),
  loading: false,
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    case NAME_SPACE + 'RECEIVE_TICKETS':
      return fromJS(action.payload);
    case NAME_SPACE + 'ADD':
      return state.update('data', data => data.insert(0, action.payload.ticket));
    case NAME_SPACE + 'SAVE':
      return state.update('data', data => {
        return data.update(data.findIndex(x => x.get('key') === action.payload.ticket.key), ticket => {
          return ticket.merge(action.payload.ticket);
        });
      });
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    case NAME_SPACE + 'ADD':
      return item(state, action);
    case NAME_SPACE + 'SAVE':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_TICKETS':
      return item(state, action);
    default:
      return state;
  }
};